import { render } from "./DashboardBoxSearch.vue?vue&type=template&id=7e14485f&scoped=true"
import script from "./DashboardBoxSearch.vue?vue&type=script&lang=js"
export * from "./DashboardBoxSearch.vue?vue&type=script&lang=js"

import "./DashboardBoxSearch.vue?vue&type=style&index=0&id=7e14485f&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e14485f"]])

export default __exports__